// UTMs validated by Marketing for every Amigobs link shared from Estigia.
// Change the values here, not in each share button.
export const AMIGOBS_BASE_URL = 'https://www.gibobs.com/plan-amigobs/';

export const AMIGOBS_UTMS = {
	utm_source: 'amigobs',
	utm_medium: 'referral',
	utm_campaign: 'amigobs'
};

// utm_content values, one per share channel (lowercase, no spaces)
export const AMIGOBS_CHANNELS = {
	WHATSAPP: 'whatsapp',
	EMAIL: 'email',
	COPY_LINK: 'copiar_enlace',
	NATIVE_SHARE: 'otras_apps'
};

export const addAmigobsUtms = (link, channel) => {
	if (!link) return link;
	try {
		const url = new URL(link);
		Object.entries(AMIGOBS_UTMS).forEach(([key, value]) => url.searchParams.set(key, value));
		if (channel) url.searchParams.set('utm_content', channel);
		return url.toString();
	} catch (e) {
		return link;
	}
};

// Keeps the friend param exactly as today; only UTMs are added.
export const buildAmigobsLink = (dataProfile, channel) => {
	const baseLink =
		dataProfile?.friendLink ||
		(dataProfile?.friendName ? `${AMIGOBS_BASE_URL}?friend=${encodeURIComponent(dataProfile.friendName)}` : undefined);
	return addAmigobsUtms(baseLink, channel);
};

const joinText = (text, link) => [text?.trim(), link].filter(Boolean).join(' ');

export const amigobsWhatsappUrl = (text, link, phone) =>
	`https://api.whatsapp.com/send?${phone ? `phone=${encodeURIComponent(phone)}&` : ''}text=${encodeURIComponent(
		joinText(text, link)
	)}`;

export const amigobsMailUrl = (subject, text, link) =>
	`mailto:?subject=${encodeURIComponent(subject || '')}&body=${encodeURIComponent(joinText(text, link))}`;

export const copyTextToClipboard = (value) => {
	const aux = document.createElement('input');
	aux.setAttribute('value', value);
	document.body.appendChild(aux);
	aux.select();
	document.execCommand('copy');
	document.body.removeChild(aux);
};
